import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=8497525a&scoped=true&"
import script from "./Task.vue?vue&type=script&lang=js&"
export * from "./Task.vue?vue&type=script&lang=js&"
import style0 from "@fortawesome/fontawesome-free-webfonts/css/fa-regular.css?vue&type=style&index=0&id=8497525a&lang=css&scoped=true&"
import style1 from "@fortawesome/fontawesome-free-webfonts/css/fa-solid.css?vue&type=style&index=1&id=8497525a&lang=css&scoped=true&"
import style2 from "@fortawesome/fontawesome-free-webfonts/css/fontawesome.css?vue&type=style&index=2&id=8497525a&lang=css&scoped=true&"
import style3 from "./Task.vue?vue&type=style&index=3&id=8497525a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8497525a",
  null
  
)

export default component.exports